import {Controller} from "stimulus";

export default class extends Controller {

    static targets = ["step", "options", "title", "progress", "back", "email", "rangeName", "rangeDescription", "exploreBtn"]

    data = {
        concern: null,
        skinType: null,
        skinConcern: null,
        blemishFrequency: null
    }

    currentStep = 0;
    path = []; // Tracks question flow for back navigation: ["q1", "q2"] or ["q1", "q3", "q4"]

    ranges = {
        essential_daily: {
            name: "Essential Daily серия",
            description: "За нормална към суха кожа, която иска нежна и ефективна ежедневна грижа.",
            exploreUrl: "https://benu.bg/skineffect-daily"
        },
        expert_daily: {
            name: "ЕКСПЕРТ Daily серия",
            description: "За тези, които искат таргетирани, ефективни ежедневни решения, вдъхновени от професионална грижа за кожата.",
            exploreUrl: "https://benu.bg/skineffect-daily"
        },
        expert_anti_acne: {
            name: "ЕКСПЕРТ Anti Acne серия",
            description: "За кожа, склонна към акне, мазна или пъпки, която търси видими резултати без раздразнение.",
            exploreUrl: "https://benu.bg/skineffect-anti-acne"
        },
        expert_pro_age: {
            name: "ЕКСПЕРТ Pro Age серия",
            description: "За зряла кожа или всеки, който иска напреднала, професионална грижа за стареене.",
            exploreUrl: "https://benu.bg/skineffect-pro-age"
        },
        expert_anti_redness: {
            name: "ЕКСПЕРТ Anti-Redness серия",
            description: "За чувствителна, склонна към зачервяване или розацея кожа, която търси охлаждане и strengthener на бариерата на кожата.",
            exploreUrl: "https://benu.bg/search?term=skineffect&brands=skineffect"
        }
    }

    connect() {
        this.path = ["q1"];
        this.renderQuestion("q1");
        this.observeModalVisibility();
    }

    reset() {
        this.data = { concern: null, skinType: null, skinConcern: null, blemishFrequency: null };
        this.currentStep = 0;
        this.path = ["q1"];
        this.renderQuestion("q1");
        const steps = this.progressTarget.querySelectorAll(".quiz-step");
        steps.forEach((el) => el.classList.remove("active"));
        steps[0].classList.add("active");

        const steps2 = this.targets.findAll("step");
        steps2.forEach(step => {
            const stepNum = parseInt(step.dataset.step);
            step.classList.toggle("hidden", stepNum !== 1);
        });

        if (this.hasEmailTarget) {
            this.emailTarget.value = "";
        }
        const mailSent = document.getElementById("skineffectMailSent");
        if (mailSent) mailSent.textContent = "";
    }

    selectOption(event) {
        const questionId = event.currentTarget.dataset.question;
        const value = event.currentTarget.dataset.value;

        if (questionId === "q1") {
            this.data.concern = value;
            if (value === "simple_care") {
                this.path = ["q1", "q2"];
                this.renderQuestion("q2");
            } else {
                this.path = ["q1", "q3"];
                this.renderQuestion("q3");
            }
        } else if (questionId === "q2") {
            this.data.skinType = value;
            this.showEmailStep();
        } else if (questionId === "q3") {
            this.data.skinConcern = value;
            if (value === "acne") {
                this.path = ["q1", "q3", "q4"];
                this.renderQuestion("q4");
            } else {
                this.showEmailStep();
            }
        } else if (questionId === "q4") {
            this.data.blemishFrequency = value;
            this.showEmailStep();
        }

        this.updateProgress();
    }

    updateProgress() {
        const steps = this.progressTarget.querySelectorAll(".quiz-step");
        const filledCount = Math.min(this.path.length, 3);
        steps.forEach((el, index) => {
            el.classList.toggle("active", index < filledCount);
        });
    }

    previousStep() {
        if (this.path.length <= 1) return;

        const removed = this.path.pop();
        if (removed === "q2") this.data.skinType = null;
        if (removed === "q3") this.data.skinConcern = null;
        if (removed === "q4") this.data.blemishFrequency = null;

        const prevQuestion = this.path[this.path.length - 1];
        this.renderQuestion(prevQuestion);
        this.updateProgress();
    }

    observeModalVisibility() {
        const modal = document.getElementById("skineffectQuizModal");
        if (!modal) return;
        modal.addEventListener("hidden.bs.modal", () => this.modalClosed());
    }

    modalClosed() {
        this.reset();
    }

    nextStep(stepNumber) {
        const steps = this.targets.findAll("step");
        steps.forEach(step => {
            const stepNum = parseInt(step.dataset.step);
            step.classList.toggle("hidden", stepNum !== stepNumber);
        });
    }

    showEmailStep() {
        this.currentStep = this.path.length + 1;
        this.updateProgress();
        this.nextStep(3);
    }

    getResultKey() {
        if (this.data.concern === "simple_care") {
            return this.data.skinType === "normal_dry" ? "essential_daily" : "expert_daily";
        }
        if (this.data.concern === "specific_concern") {
            if (this.data.skinConcern === "acne") return "expert_anti_acne";
            if (this.data.skinConcern === "ageing") return "expert_pro_age";
            if (this.data.skinConcern === "redness") return "expert_anti_redness";
        }
        return "essential_daily";
    }

    getResultCarouselGroup() {
        const key = this.getResultKey();
        if (key === "essential_daily" || key === "expert_daily") return "daily";
        if (key === "expert_anti_acne") return "acne";
        if (key === "expert_pro_age") return "pro_age";
        if (key === "expert_anti_redness") return "anti_redness";
        return "daily";
    }

    showResult() {
        const key = this.getResultKey();
        const range = this.ranges[key] || this.ranges.essential_daily;

        if (this.hasRangeNameTarget) this.rangeNameTarget.textContent = range.name;
        if (this.hasRangeDescriptionTarget) this.rangeDescriptionTarget.textContent = range.description;
        if (this.hasExploreBtnTarget) this.exploreBtnTarget.href = range.exploreUrl;

        this.nextStep(4);

        const group = this.getResultCarouselGroup();
        this.element.querySelectorAll(".quiz-carousel-wrap").forEach((wrap) => {
            wrap.classList.toggle("hidden", wrap.dataset.quizGroup !== group);
        });

        const activeWrap = this.element.querySelector(`.quiz-carousel-wrap[data-quiz-group="${group}"]`);
        if (activeWrap && typeof $ !== "undefined") {
            const carousel = activeWrap.querySelector(".owl-quiz-results");
            if (carousel && $(carousel).data("owl.carousel")) {
                $(carousel).trigger("refresh.owl.carousel");
            }
        }
    }

    renderQuestion(questionId) {
        const questions = {
            q1: {
                title: "Какъв е основният проблем с кожата ти в момента?",
                options: [
                    { value: "simple_care", label: "Искам лесна, нежна грижа за всеки ден" },
                    { value: "specific_concern", label: "Имам конкретен кожен проблем, който искам да адресирам" }
                ]
            },
            q2: {
                title: "Какъв е твоят тип кожа?",
                options: [
                    { value: "normal_dry", label: "Нормална към суха кожа — искам нежна и ефективна ежедневна грижа" },
                    { value: "normal_combination", label: "Нормална към комбинирана кожа — искам таргетирани решения за всеки ден" }
                ]
            },
            q3: {
                title: "Кой от тези проблеми описва кожата ти най-точно?",
                options: [
                    { value: "acne", label: "Акне, пъпки, мазна кожа" },
                    { value: "ageing", label: "Видими признаци на стареене (линии, стегнатост, блясък)" },
                    { value: "redness", label: "Зачервяване, раздразнение, чувствителна или склонна към розацея кожа – тази серия я нямаме" }
                ]
            },
            q4: {
                title: "Колко често се бориш с несъвършенства?",
                options: [
                    { value: "regular", label: "Редовно или постоянно" },
                    { value: "occasional", label: "От време на време, но все пак искам таргетирана грижа" }
                ]
            }
        };

        const q = questions[questionId];
        if (!q) return;

        this.currentStep = this.path.length;
        if (this.hasTitleTarget) this.titleTarget.textContent = q.title;

        this.optionsTarget.innerHTML = q.options.map(opt => `
            <button type="button" class="quiz-option-text"
                data-action="click->skineffect-quiz#selectOption"
                data-value="${opt.value}"
                data-question="${questionId}">
                ${opt.label}
            </button>
        `).join("");

        this.backTarget.hidden = this.path.length <= 1;
    }

    submitQuiz(event) {
        event.preventDefault();
        const email = this.emailTarget.value;
        const url = event.currentTarget.dataset.url;

        $.ajax({
            url: url,
            method: "POST",
            contentType: "application/json",
            data: JSON.stringify({
                email: email,
                productUrl: null,
                answers: this.data
            }),
            success: () => {
                document.getElementById("skineffectMailSent").textContent = "Проверете вашата поща!";
                this.showResult();
            },
            error: (xhr, status, error) => {
                console.error("Error submitting quiz:", error);
            }
        });
    }
}
